export const calculateSessionDuration = (startedAt: string, lastInteraction: string): string => {
    const start = new Date(startedAt);
    const end = new Date(lastInteraction);

    const diffInMilliseconds = end.getTime() - start.getTime();
    const hours = Math.floor(diffInMilliseconds / (1000 * 60 * 60));
    const minutes = Math.floor((diffInMilliseconds % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((diffInMilliseconds % (1000 * 60)) / 1000);
    if (hours > 0) {
        return `${hours}h ${minutes}m ${seconds}s`;
    }
    return `${minutes}m ${seconds}s`;
};

export const formatDateTime = (date: string): string => {
    return new Date(date).toLocaleString('es-AR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
    });
};

export const calculateTotalDuration = (sessions: any[]): string => {
    console.log(sessions);
    const totalMinutes = sessions.reduce((acc, session) => {
        const start = new Date(session.startedAt);
        const end = session.endedAt ? new Date(session.endedAt) : new Date(session.lastInteraction);
        const diffInMinutes = (end.getTime() - start.getTime()) / (1000 * 60);
        return acc + diffInMinutes;
    }, 0);

    const hours = Math.floor(totalMinutes / 60);
    const minutes = Math.floor(totalMinutes % 60);

    if (hours > 0) {
        return `${hours}h ${minutes}m`;
    }
    return `${minutes}m`;
};

export const calculateTotalDurationByDay = (sessions: any[]): string => {
    // Primero calculamos el tiempo total en segundos
    const totalSeconds = sessions.reduce((acc, session) => {
        const start = new Date(session.startedAt);
        const end = new Date(session.lastInteraction);
        const diffInSeconds = (end.getTime() - start.getTime()) / 1000;
        return acc + diffInSeconds;
    }, 0);

    // Convertimos los segundos totales a horas, minutos y segundos
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = Math.floor(totalSeconds % 60);

    // Formateamos la salida
    if (hours > 0) {
        return `${hours}h ${minutes}m ${seconds}s`;
    } else if (minutes > 0) {
        return `${minutes}m ${seconds}s`;
    }
    return `${seconds}s`;
}; 